var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossedLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,15.5v6c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5v-6c0-.276,.224-.5,.5-.5s.5,.224,.5,.5Zm11.354,8.354c-.098,.098-.226,.146-.354,.146s-.256-.049-.354-.146L.146,.854C-.049,.658-.049,.342,.146,.146S.658-.049,.854,.146L3.701,2.994c.795-.635,1.775-.994,2.799-.994h11c2.481,0,4.5,2.019,4.5,4.5v2c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5v-2c0-1.93-1.57-3.5-3.5-3.5h-5V11.793l11.354,11.354c.195,.195,.195,.512,0,.707ZM4.414,3.707l7.086,7.086V3H6.5c-.758,0-1.484,.257-2.086,.707Zm-1.914,2.293c-.276,0-.5,.224-.5,.5v2c0,.276,.224,.5,.5,.5s.5-.224,.5-.5v-2c0-.276-.224-.5-.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedLetter);
export default __webpack_public_path__ + "static/media/crossedLetter.96f911d20405ac39bed0c297eaeabba8.svg";
export { ForwardRef as ReactComponent };